module.exports = __webpack_public_path__ + "static/media/Frame 1261154683.471af32c.svg";